export const setItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value || ''))
}
export const getItem = (key) => {
  const value = localStorage.getItem(key)
  return value ? JSON.parse(value) : value
}
export const removeItem = (key) => {
  localStorage.removeItem(key)
}
